import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/">
              <img 
                src="https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/72qb31et_Better%20Than%20Yesterday%20%28Sweatshirts%29-2.png" 
                alt="PAW Padelarena Logo" 
                className="h-20 w-auto mb-6 hover:scale-105 transition-transform"
              />
            </Link>
            <p className="text-slate-400 max-w-md leading-relaxed">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">{t.footer.quickLinks}</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })} className="text-slate-400 hover:text-white transition-colors">
                  {t.nav.about}
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('facilities')?.scrollIntoView({ behavior: 'smooth' })} className="text-slate-400 hover:text-white transition-colors">
                  {t.nav.facilities}
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} className="text-slate-400 hover:text-white transition-colors">
                  {t.nav.services}
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="text-slate-400 hover:text-white transition-colors">
                  {t.nav.contact}
                </button>
              </li>
              <li>
                <Link to="/immobilien" className="text-slate-400 hover:text-white transition-colors">
                  {t.footer.realEstate}
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold mb-6">{t.footer.followUs}</h3>
            <div className="flex gap-4">
              <a href="https://facebook.com/padelarena" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center hover:bg-white/20 transition-all">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/padelarenawadenswil/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center hover:bg-white/20 transition-all">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://youtube.com/@padelarena" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center hover:bg-white/20 transition-all">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {currentYear} Padelarena Wädenswil. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

// Real Estate Page Component
